import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPngToWebpConfig } from '@/data/landingConfig/landingPngToWebpConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PngToWebp } from './schemaObject';

interface Props {}
const PngToWebpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PngToWebp} />
			<LandingTemplate
				data={landingPngToWebpConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default PngToWebpConverter;
